import { Model } from 'modules/core/lib/mobx-rest'

interface IManualIncidence {
  [key: string]: any
}

class ManualIncidence extends Model<IManualIncidence> {
  static urlRoot() {
    return '/bookkeepers_management/manual_incidences'
  }
}

export default ManualIncidence
